const palettes: ['blue'] = ['blue'];

export default palettes;
